import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/store";
import { initialize } from "../redux/createOpinionReducer";
import { setErrorObj } from "../redux/errorReducer";
import { T } from "react-translator-component";
import moment from "moment";
import {
  Avatar, Button,
  ListItem, ListItemAvatar, ListItemText,
  Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Typography,
} from "@mui/material";
import CreateIcon from '@mui/icons-material/Create';
import apiServices from "../services/apiServices";
import { convertUserImage } from "../../util/utils";
import { isNavigator } from "../util/util";
import LoadingModal from "../../components/LoadingModal";
import AdminPageFrame from "../components/AdminPageFrame";
import ReadMore from "../components/ReadMore";
import { colors } from "../../common/colors";
import profile from "../../assets/images/profile_img.png";

export default function SuggestionList() {
  const { admin } = useSelector((state: any) => state.adminAuth);
  const navigate = useNavigate()
  const dispatch = useAppDispatch();
  const [loader, setLoader] = useState<boolean>(false);
  const [pagination, setPagination] = useState<any>({});
  const [suggestions, setSuggestion] = useState<any>([]);

  useEffect(() => {
    getSuggestion();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSuggestion = async () => {
    try {
      setLoader(true);
      const res = await apiServices.getSuggestions(1);
      setSuggestion(res.suggestions);
      setPagination(res.pagination);
      setLoader(false);
    } catch (error: any) {
      setLoader(false);
      dispatch(setErrorObj(error))
    }
  };
  const handleMore = async () => {
    if (pagination?.next_page > 0) {
      try {
        setLoader(true);
        const res = await apiServices.getSuggestions(pagination.next_page);
        setLoader(false);
        const newItems = [...suggestions, ...res.suggestions];
        setSuggestion(newItems);
        setPagination(res.pagination);
      } catch (error: any) {
        setLoader(false);
        dispatch(setErrorObj(error))
      }
    }
  };

  const handleClickCreatePost = (suggestionId?: number) => {
    if (!isNavigator(admin)) return

    dispatch(initialize())
    navigate("/mng/create_opinion_post", { state: { suggestionId: suggestionId } });
  }

  return (
    <AdminPageFrame>
      <TableContainer component={Paper}>
        <LoadingModal visible={loader}/>

        <div style={{ height: 20 }}></div>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography>{T("mng_navigator_suggestions")}</Typography>
              </TableCell>
              <TableCell align="right">
                <Button onClick={() => getSuggestion()}>
                  {T("mng_refresh")}
                </Button>
                {isNavigator(admin) && (
                  <Button onClick={() => handleClickCreatePost()}>
                    <CreateIcon />
                    {T("mng_create_new_opinion_post")}
                  </Button>
                )}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ padding: "10px" }}>
            {suggestions.map((item: any, index: number) => (
              <TableRow key={index}>
                <TableCell scope="row" sx={{ border: "none", width: "80%" }}>
                  <ListItem alignItems="flex-start" style={{ wordWrap: "break-word" }}>
                    <ListItemAvatar>
                      <Avatar
                        alt="Remy Sharp"
                        src={
                          item?.user?.image !== null
                            ? convertUserImage(item?.user?.image)
                            : profile
                        }
                      />
                    </ListItemAvatar>
                    <ListItemText
                      sx={{ color: colors.farm_blue200, wordWrap: "break-word" }}
                      style={{ maxWidth: "fit-content", wordBreak: "break-all" }}
                      primary={
                        <Typography>{ item?.user?.nickname }</Typography>
                      }
                      secondary={
                        <>
                          <Typography
                            style={{
                              display: "inline",
                              wordWrap: "break-word",
                              maxWidth: 600,
                              color: "rgba(0, 0, 0, .6)"  // imitate MuiTypography-root
                            }}
                          >
                            {item?.title}
                          </Typography>
                          <Typography sx={{ fontSize: 10, color: colors.farm_gray200 }}>
                            {moment(item?.created_at).format("MMMM Do YYYY, h:mm a")}
                          </Typography>
                        </>
                      }
                      disableTypography
                    />
                  </ListItem>
                </TableCell>
                {isNavigator(admin) && (
                  <TableCell align="right" sx={{ border: "none" }}>
                    <Button onClick={() => handleClickCreatePost(item.id)}>
                      <CreateIcon />
                      {T("mng_create_new_opinion_post_from_suggestion")}
                    </Button>
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <ReadMore open={pagination.next_page > 0} onClick={() => handleMore()} />
      </TableContainer>
    </AdminPageFrame>
  );
}
